const SubprofilCbt = {
    idSubProfilCbt: null,
    idProfilCbt: null,
    idMataPelajaran: null,
    idTematik: null,
    ketuntasanMinimum: 75,
    durasi: 60,
    prosentaseEssay: 0,
    jumlahSoal: 0,
    pointBenar: 1,
    pointSalah: 0,
    pointTakTerjawab: 0,
    random: 0,
    idKategoriSubProfil: null
}

export default SubprofilCbt;